import { generateCsvDownload } from '../lib/csv';
import { getFormattedDate } from '../lib/dates';
import { getRounded } from '../lib/numbers';

export function exportCertifiedFields(fields) {
  const filename = `fields-export-certified-${fields[0].growerOperationId}.csv`;
  const rows = fields.map((f) => ({
    field_name: f.fieldName,
    farm_name: f.farmName,
    field_id: f.fieldId,
    acres: getRounded(f.acres, 2),
    planned_crop: f.plannedCrop,
    row_spacing: f.rowSpacing,
    early_fungicide: f.earlyFungicide,
    late_fungicide: f.lateFungicide,
    tillage_type: f.tillageType,
    cover_crop: f.coverCrop,
    starter_fertilizer: f.starterFertilizer,
    trait_package: f.traitPackage,
    date_certified: f.createdDate ? getFormattedDate(f.createdDate) : '-',
    hexbin_status: f.hexbinProcessed,
    elevation_status: f.elevationProcessed,
    aaid: f.aaManagedId,
  }));

  return generateCsvDownload(rows, filename);
}

export function exportUncertifiedFields(fields) {
  const filename = `fields-export-uncertified-${fields[0].growerOperationId}.csv`;
  const rows = fields.map((f) => ({
    field_name: f.fieldName,
    farm_name: f.farmName,
    field_id: f.fieldId,
    acres: getRounded(f.acres, 2),
    validated: f.validated,
    validation_error: f.validateError,
    date_uploaded: f.createdDate ? getFormattedDate(f.createdDate) : '-',
    aaid: f.aaManagedId,
  }));

  generateCsvDownload(rows, filename);
}
